module.exports = __webpack_public_path__ + "assets/img/940e-lc.svg";